<template>
  <form-component
    ref="pollForm"
    class="poll-form"
    @submit.prevent="handleFormSubmit"
  >
    <input-group
      :id="formId"
      class="poll-form__options"
      data-test-id="poll-form-options"
      :type="pollInputType"
      :input-options="formattedAnswerOptions"
      @input="setVotedAnswers"
    />
    <button
      ref="submit"
      type="submit"
      class="poll-form__submit-button button"
    >Submit</button>
  </form-component>
</template>

<script>
import InputGroup from '@/components/Inputs/InputGroup.vue';
import { ENGAGEMENT_VOTE } from '@/graphql/mutations/engagement-toolkit-mutations';

export default {
  name: 'PollForm',
  components: {
    InputGroup,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    formId: {
      type: String,
      required: true,
    },
    isMultiSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedOptionId: [],
      votedAnswers: [],
    };
  },
  computed: {
    pollInputType() {
      return this.isMultiSelect ? 'checkbox' : 'radio';
    },
    formattedAnswerOptions() {
      return this.options.map((i) => ({
        label: i.name,
        value: i.id.toString(),
        id: i.id,
        votes: i.votes,
        name: `poll_${this.formId}`,
      }));
    },
  },
  methods: {
    setVotedAnswers(payload) {
      if (!this.isMultiSelect) {
        this.votedAnswers = [payload.value];
        this.setOptionChecked(payload);
        return;
      }
      if (this.isMultiSelect) {
        const indexOfPreviousInput = this.votedAnswers.indexOf(payload.value);

        if (indexOfPreviousInput >= 0) {
          this.votedAnswers.splice(indexOfPreviousInput, 1);
        } else {
          this.votedAnswers.push(payload.value);
        }
        this.setOptionChecked(payload);
      }
    },
    setOptionChecked(selectedOptionInput) {
      const optionIndex = this.formattedAnswerOptions.findIndex(
        (option) => option.value === selectedOptionInput.value,
      );

      if (optionIndex >= 0 && selectedOptionInput.checked) {
        this.formattedAnswerOptions[optionIndex].checked = true;
      } else {
        this.formattedAnswerOptions[optionIndex].checked = false;
      }
    },
    handleFormSubmit() {
      if (this.votedAnswers.length === 0) {
        this.$store.dispatch('addToastNotification', {
          toastType: 'error',
          description: 'Please choose a valid poll answer.',
        });
        return;
      }
      this.$apollo.mutate({
        mutation: ENGAGEMENT_VOTE,
        variables: {
          engagementId: this.formId,
          optionIds: this.votedAnswers,
        },
      }).then((response) => {
        this.$emit('optionSelected', response.data?.engagementVote);
      }).catch((error) => {
        const alreadyVotedRegex = /Poll closed or vote\(s\) are invalid/;
        if (alreadyVotedRegex.test(error)) {
          this.$store.dispatch('addToastNotification', {
            toastType: 'error',
            description: 'Thank you! You’ve already voted.',
          });
          this.changeToResults();
        } else {
          this.$store.dispatch('addGenericErrorNotification');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_poll-form';
</style>
